<template>
  <div>
    <div style="margin-top: 20px; text-align: center">
      <h3>Please do not close and refresh browser</h3>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <h4>Redirect to payment getway website for payment</h4>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <img src="../assets/images/payprocess.gif" />
    </div>
  </div>
  <!-- <form id="frmData" action="https://surepay.ndml.in/SurePayPayment/refundTransaction" method="post">
        <div>
            <input type="hidden" id="surePayMerchantId" name="surePayMerchantId" v-model="surePayMerchantId" />
            <input type="hidden" id="orderId" name="orderId" v-model="orderId" />
            <input type="hidden" id="refundReqId" name="refundReqId" v-model="refundReqId" />
            <input type="hidden" id="bankTransactionNo" name="bankTransactionNo" v-model="bankTransactionNo" />
            <input type="hidden" id="serviceId" name="serviceId" v-model="serviceId" />
            <input type="hidden" id="surePayTxnId" name="surePayTxnId" v-model="surePayTxnId" />
            <input type="hidden" id="transactionAmount" name="transactionAmount" v-model="transactionAmount" />
            <input type="hidden" id="refAmount" name="refAmount" v-model="refAmount" />
            <input type="hidden" id="additionalField1" name="additionalField1" v-model="additionalField1" />
            <input type="hidden" id="additionalField2" name="additionalField2" v-model="additionalField2" />
            <input type="hidden" id="additionalField3" name="additionalField3" v-model="additionalField3" />
            <input type="hidden" id="additionalField4" name="additionalField4" v-model="additionalField4" />
            <input type="hidden" id="additionalField5" name="additionalField5" v-model="additionalField5" />
            <input type="hidden" id="checksum" name="checksum" v-model="checksum" />
            <br />
            <div style="margin-top: 20px; text-align: center">
                <h3>Please do not close and refresh browser</h3>
            </div>
            <div style="color: red; margin-top: 20px; text-align: center">
                <h4>Redirect to payment getway website for payment</h4>
            </div>
            <div style="color: red; margin-top: 20px; text-align: center">
                <img src="../assets/images/payprocess.gif" />
            </div>
        </div>
  </form>-->
</template>
<script>
import axios from "axios";
import Router from "vue-router";
import config from "@/router/globalConfig";
import RefundJS from "./servicesJS/Refund.js";
export default {
  name: "TransRequest",
  data() {
    return {
      surePayMerchantId: -1,
      orderId: -1,
      refundReqId: [],
      //request for payment gatway server
      bankTransactionNo: "",
      serviceId: "",
      surePayTxnId: "",
      transactionAmount: "",
      refAmount: "",
      additionalField1: "",
      additionalField2: "",
      additionalField3: "",
      additionalField4: "",
      additionalField5: "",
      checksum: "",
      CancelReason: "",
      pageName: ""
    };
  },
  methods: {
    getData() {
      const data = {
        bookingID: this.bookingID,
        refundReason: this.CancelReason
      };
      RefundJS.getTransRequest(data).then(
        response => {
          if (response.data.isSuccess) {
            this.$root.$data.BookingID = this.bookingID;
            this.$root.$data.Response = response.data.result;
            this.$root.$data.isSuccess = response.data.isSuccess;
            this.$root.$data.isRefund = true;
            this.$root.$data.PageName = this.pageName;
            this.$router.push({ name: "RefundResponse" });
          } else {
            this.$root.$data.BookingID = this.bookingID;
            this.$root.$data.isSuccess = response.data.isSuccess;
            this.$root.$data.isRefund = false;
            this.$router.push({ name: this.pageName });
          }
        },
        error => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        },
        failure => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        }
      );
    }
  },
  mounted() {
    if (this.$root.$data.BookingID != null) {
      let me = this;
      // this.PayBooking = this.$root.$data.PayBooking;
      this.pageName = this.$root.$data.PageName;
      this.bookingID = this.$root.$data.BookingID;
      this.CancelReason = this.$root.$data.CancelReason;
      window.setTimeout(function() {
        me.getData();
      }, 3000);
    } else {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/RefundRequest.vue